module.exports = __webpack_public_path__ + "static/img/108002.98fea07e.png";